import React from 'react'
import Header from '../../../Components/Header'

function ObjectiveMarkers({ level = 2 }) {
    return (
        <div>
            <Header text={"Objective Markers"} level={level}/>
            <div>
                Data
            </div> <br />
        </div>
    )
}

export default ObjectiveMarkers